import { toast, Slide } from 'vue3-toastify';

export default function useToast() {
    const options = {
        transition: toast.TRANSITIONS.SLIDE,
        autoClose: 3000,
        newestOnTop: true,
    }

    const info = function(message, paramOptions = {}) {
        toast(message, {
            type: 'info',
            ...options,
            ...paramOptions
        })
    }

    const success = function(message, paramOptions = {}) {
        toast(message, {
            type: 'success',
            ...options,
            ...paramOptions
        })
    }

    const error = function(message, paramOptions = {}) {
        toast(message, {
            type: 'error',
            ...options,
            ...paramOptions
        })
    }

    const warn = function(message, paramOptions = {}) {
        toast(message, {
            type: 'warning',
            ...options,
            ...paramOptions
        })
    }

    const defaultToast = function(message, paramOptions = {}) {
        toast(message, {
            type: 'default',
            ...options,
            ...paramOptions
        })
    }

    return {
        defaultToast,
        info,
        success,
        error,
        warn
    }
}